import { flow, types, cast } from 'mobx-state-tree';
import { Telephony, Messengers } from '../../http-requests';
import { IParams } from '../../http-requests/types';

export const CommonStore = types
  .model({
    qrCodeTimerValue: types.optional(types.string, ''),
    requestsListAutoReload: types.optional(types.boolean, false),
    callsInTranscribation: types.optional(types.array(types.string), []),
    theme: types.optional(
      types.enumeration(['light', 'dark'] as const),
      'light'
    ),
  })
  .volatile((self) => ({
    qrCode: null,
  }))
  .actions((self) => ({
    setQrCodeTimerValue(date: string) {
      self.qrCodeTimerValue = date;
    },
    setRequestsListAutoReload(value: boolean) {
      self.requestsListAutoReload = value;
      localStorage.setItem(
        'requests_list_reload',
        self.requestsListAutoReload.toString()
      );
    },
    setCallsInTranscribation(callId: string) {
      self.callsInTranscribation.push(callId);
    },
    removeCallsInTranscribation(callId: string) {
      self.callsInTranscribation = cast(
        self.callsInTranscribation.filter((id) => id !== callId)
      );
    },
    setTheme(newTheme: typeof self.theme) {
      self.theme = newTheme;
      localStorage.setItem('theme', newTheme);
      document.body.setAttribute('data-theme', newTheme);
    },
    toggleTheme() {
      const newTheme = self.theme === 'light' ? 'dark' : 'light';

      self.theme = newTheme;
      localStorage.setItem('theme', newTheme);
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme') as
        | typeof self.theme
        | undefined;

      // TODO: Когда полностью Dispatcher будет готов к темной теме -
      // расскомментировать код снизу и убрать self.theme = savedTheme ?? 'light';

      // if (!savedTheme) {
      //   const prefersDark = window.matchMedia(
      //     '(prefers-color-scheme: dark)'
      //   ).matches;

      //   savedTheme = prefersDark ? 'dark' : 'light';
      // }

      // self.theme = savedTheme;
      self.theme = savedTheme ?? 'light';
      localStorage.setItem('theme', savedTheme ?? 'light');
    },
    initTranscribation: flow(function* (callId: string) {
      try {
        const response = yield Telephony.InitTranscribation(callId);
        return self.callsInTranscribation;
      } catch (err) {
        console.error(err);
        throw err;
      }
    }),
    sendTelegramMessage: flow(function* (data: IParams) {
      try {
        const response = yield Messengers.SendTelegramMessage(data);
        console.log(response);
      } catch (e) {
        console.error(e);
        throw e;
      }
    }),
  }));
